var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-details-box pt-0" }, [
    _c("div", { staticClass: "event-registration-box event-rg-form" }, [
      _c("div", { staticClass: "event-thankyou-msg" }, [
        _c("h4", { staticClass: "mb-4" }, [
          _vm._v(_vm._s(_vm.eventConfig["confirmation-label-thankyou"])),
        ]),
        _vm._v(" "),
        _c("b", { staticClass: "event-msg-heading" }, [
          _vm._v(_vm._s(_vm.eventConfig["confirmation-label-details"])),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(_vm._s(_vm.referenceLabel)),
          _c("br"),
          _vm._v(_vm._s(_vm.amountLabel)),
        ]),
        _vm._v(" "),
        _vm.isTickethasIndividual ? _c("hr") : _vm._e(),
        _vm._v(" "),
        _vm.isTickethasIndividual
          ? _c("b", [_vm._v("Individual Tickets")])
          : _vm._e(),
        _vm._v(" "),
        _vm.isTickethasIndividual
          ? _c(
              "ul",
              _vm._l(_vm.persons, function (person, index) {
                return _c("li", { key: index }, [
                  _vm._v(
                    _vm._s(person.firstName) + " " + _vm._s(person.lastName)
                  ),
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isTickethasIndividual && _vm.receipt.AmountPaid > 0
          ? _c("p", [
              _vm._v(_vm._s(_vm.eventConfig["confirmation-label-taxreceipt"])),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isTicketHasTable ? _c("hr") : _vm._e(),
        _vm._v(" "),
        _vm.isTicketHasTable
          ? _c("b", { staticClass: "event-msg-heading" }, [
              _vm._v(_vm._s(_vm.eventConfig["confirmation-label-table"])),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isTicketHasTable
          ? _c("p", [
              _vm._v(
                _vm._s(_vm.eventConfig["confirmation-label-table-details"])
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isTicketHasTable
          ? _c("div", { staticClass: "event-btn d-flex flex-wrap" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    href:
                      this.$store.state.URL +
                      "/guesttableseating?id=" +
                      _vm.receipt.TableBookingCaptainId +
                      "&ck=" +
                      _vm.receipt.TableBookingCK +
                      "&ordernumber=" +
                      _vm.receipt.TableBookingOrderNumber,
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.eventConfig["confirmation-label-table-guests"])
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }